import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-college-map',
  templateUrl: './college-map.component.html',
  styleUrls: ['./college-map.component.scss']
})
export class CollegeMapComponent implements OnInit {

  isLoading = false;
  isDataLoading = false;

  career_type = 1; // monthly = 1;annually = 2;

  // Filter drop-down options
  filterOptions = {
    state: [],
    city: [],
    course: [],
    courseDuration: [],
    fees: [],
    typeOfCollege: []
  };

  // Filter selected values
  state: [];
  city: [];
  course: [];
  courseDuration: [];
  fees: [];
  typeOfCollege: [];

  showRecords;
  search;

  constructor(private dashboardService: DashboardService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.dashboardService.getRoadmapTabFlag().subscribe(data => {
      if (data === 'college-map') {
        // this.getStudentInfo();
        console.log('college-map');
      }
    });
  }

  ngOnInit() {
    this.filterOptions.state = [{ name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' }]
  }


  updateUIData() {
    // this.isDataLoading = true;
  }

  demo() {

  }

  paginate(event) {

  }

}
